// TODO when API is completed needed to add call through useffect bound on right carousel arrow

import React, { useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";

interface IProps extends WithTranslation {
  richMedia: RichMedia;
}

interface CarouselButton {
  Columns: number;
  Rows: number;
  ActionType: string;
  ActionBody: string;
  Text?: string;
  Image?: string;
}

interface RichMedia {
  Buttons: CarouselButton[];
  Navigation?: {
    previous?: CarouselButton;
    next?: CarouselButton;
  };
}

interface NewsItem {
  title: string;
  image: string;
  description: string;
  link: string;
}

function groupButtonsByTriplet(buttons: CarouselButton[]): NewsItem[] {
  const grouped: NewsItem[] = [];

  for (let i = 0; i < buttons.length; i += 3) {
    const [titleBtn, imageBtn, descBtn] = buttons.slice(i, i + 3);
    grouped.push({
      title: titleBtn?.Text || "",
      image: imageBtn?.Image || "",
      description: descBtn?.Text || "",
      link: titleBtn?.ActionBody || "#",
    });
  }

  return grouped;
}

const ChatItemCarousel: React.FC<IProps> = ({ richMedia, t }) => {
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);

  const allNewsItems = groupButtonsByTriplet(richMedia.Buttons);
  const totalNewsCount = allNewsItems.length;
  const currentNews = allNewsItems[currentNewsIndex];

  const handleNextNews = () => {
    if (currentNewsIndex < totalNewsCount - 1) {
      setCurrentNewsIndex(currentNewsIndex + 1);
    }
  };

  const handlePrevNews = () => {
    if (currentNewsIndex > 0) {
      setCurrentNewsIndex(currentNewsIndex - 1);
    }
  };

  const itemsPerPage = 5;
  const currentPage = Math.floor(currentNewsIndex / itemsPerPage) + 1;
  const totalPages = Math.ceil(totalNewsCount / itemsPerPage);

  return (
    <div className="carousel-wrapper">
      <button
        className="carousel-prev"
        onClick={handlePrevNews}
        title={t("CAROUSEL_RICH_MEDIA.previous")}
        disabled={currentNewsIndex === 0}
      >
        ❮
      </button>

      <div className="carousel-container">
        {currentNews ? (
          <div
            className="carousel-item"
            onClick={() => window.open(currentNews.link, "_blank")}
          >
            <p className="carousel-title">{currentNews.title}</p>
            <img
              src={currentNews.image}
              alt="carousel-img"
              className="carousel-img"
            />
            <p className="carousel-description">{currentNews.description}</p>
            <div className="news-index">{currentNewsIndex + 1}</div>
          </div>
        ) : (
          <p>{t("CAROUSEL_RICH_MEDIA.no_news_available")}</p>
        )}
      </div>

      <button
        className="carousel-next"
        onClick={handleNextNews}
        title={t("CAROUSEL_RICH_MEDIA.next")}
        disabled={currentNewsIndex === totalNewsCount - 1}
      >
        ❯
      </button>

      {/* <div className="pagination-info">
        {t("CAROUSEL_RICH_MEDIA.page")} {currentPage} / {totalPages}
      </div> */}
    </div>
  );
};

export default withTranslation()(ChatItemCarousel);
